import { render } from "./App.vue?vue&type=template&id=90dac9ce"
const script = {}

import "./App.vue?vue&type=style&index=0&id=90dac9ce&lang=css"
import "./App.vue?vue&type=style&index=1&id=90dac9ce&lang=scss"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__